// Bundle theme module
import NSTheme from './NSTheme';
import Helper from './Classes/Helper';
import Accordion from './Classes/Accordion';
import FocusHandler from './Classes/FocusHandler';
import Jump from './Classes/Jump'
import LazyLoad from './Classes/Lazyload';
import Sticky from '../../node_modules/sticky-js';
import ResponsiveTable from "./Classes/ResponsiveTable";
import Toggler from './Classes/Toggler';
import Navigation from './Classes/Navigation';
import SetTargetBlank from './Classes/SetTargetBlank';
import FootnoteSpan from './Classes/FootnoteSpan';
import Gri from './Classes/Gri';
import CountUpNumbers from './Classes/countUpNumbers';
import SubnavigationMarkup from './Classes/SubnavigationMarkup';
import SubnavigationFunctionality from './Classes/SubnavigationFunctionality';
import Video from "./Classes/Video";

module.exports = NSTheme;

(function () {
  document.addEventListener('DOMContentLoaded', () => {

    new Navigation({
      menuTogglerSelector: '.js-nav-dropdown-toggler',
      menuTogglerMobileSelector: '.burger',
      openButtonSelector: '.search-toggle',
      togglingContainerSelector: '.site-search'
    });


    new Toggler({
      togglerButtonSelector: '.ns-portrait__readmore-toggle',
      togglerContainerSelector: '.ns-portait__readmore-content'
    });

    new FocusHandler();

    new Accordion({
      accordions: '.js-toggle-accordion'
    });

    new Jump({
      graphicSelector: '.ns-graphic'
    });

    new LazyLoad();

    if (Helper.isDesktop()) {
      new Sticky('.header__bottom');
    }

    new ResponsiveTable({
      tableSelector: '.ns-table-wrap table',
      tableWrapperSelector: '.ns-table-wrap',
      breakPointLg: 1200,
      breakPointMd: 768,
      breakPointSm: 480,
      colCountNoSplit: 3,
      colCountEarlyBreak: 7,
      noSplitArray: []
    });

    new SetTargetBlank({
      targetBlanks: '.js-anchor-target'
    });

    new FootnoteSpan({
      footnoteSelector: 'p.ns-style-footnote'
    });


    new CountUpNumbers({
      numbersSelector: '.ns-keyfigures__item:not(.no-countup) .ns-keyfigures__number',
      classIn: 'is-in-viewport',
      classOut: 'is-not-in-viewport',
      langArray: ['de-DE', 'en-US'],
      decimalArray: [',', '.'],
      thousandSepArray: ['', '']
    });

    new SubnavigationMarkup({
      header: '.ns-header',
      linkClass: '.menu__item--level-1'
    });

    new SubnavigationFunctionality({});

    new Gri();

    new Video();

  })
})();
